import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'cm-dp-scsv-dialog',
  template: `
    <h4 mat-dialog-title>CSV import result</h4>
    <div mat-dialog-content class="d-flex flex-column">
      <div>Number of lines processed: {{data.result.processedLinesCount}}</div>
      <div>Number of errors: {{data.result.errorsCount}}</div>
      <div class="mt20" style="height: 400px; overflow-y: auto">
        <ul>
          <li *ngFor="let adUnit of data.errorAdUnits">{{adUnit}}</li>
        </ul>
      </div>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </div>
  `,
})
export class SitesCsvImportResultDialogComponent {

  constructor(public dialogRef: MatDialogRef<SitesCsvImportResultDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
